import React from 'react'
import Modal from 'react-bootstrap/Modal'
import { useTranslation } from 'react-i18next'
import 'common/styling/modal-styling.scss'
import '../Modal.scss'

interface ILoanOfferConfirmation {
    showModal: boolean
    handleCancel: any
    handleContinue: any
}

export const LoanOfferConfirmationModal = ({
    showModal,
    handleCancel,
    handleContinue,
}: ILoanOfferConfirmation) => {
    const { t } = useTranslation()

    return (
        <Modal
            show={showModal}
            onHide={handleCancel}
            animation={false}
            centered
            className="loanofferconfirmation-modal"
            backdrop="static">
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
                <div>{t('LoanOfferConfirmationBody')}</div>
            </Modal.Body>
            <Modal.Footer>
                <button
                    id="loan-offer-confirmation-cancel-button"
                    type="button"
                    className="btn btn-outline-darkgray"
                    onClick={() => {
                        setTimeout(() => {
                            handleCancel()
                        }, 400)
                    }}>
                    {t('Cancel')}
                </button>
                <button
                    id="loan-offer-confirmation-continue-button"
                    type="button"
                    className="btn btn-primary"
                    onClick={() => {
                        setTimeout(() => {
                            handleContinue()
                        }, 400)
                    }}>
                    {t('Continue')}
                </button>
            </Modal.Footer>
        </Modal>
    )
}